<template>
  <div>
    <div class="navbar nav-main w-100" style="background-color: #23409a; color: white">
      <h3 class="w-100 text-center my-3">ลงทะเบียนใช้งาน</h3>
    </div>
    <div class="mb-2 flex-all-center session-with-nav">
      <div>
        <v-img
          class="my-0 radius-circle"
          style="width: 170px; height: auto"
          src="@/assets/logo_long.png"
        ></v-img>
      </div>
      <div>
        <v-img
          class="my-0 radius-circle"
          style="width: 170px; height: auto"
          src="@/assets/logo_long_nm.png"
        ></v-img>
      </div>
    </div>
    <ValidationObserver ref="observer">
      <div class="w-100 px-8">
        <h6 class="text-blue mb-8 fs-18">กรุณากรอกข้อมูลผู้ทำสัญญา</h6>
        <div class="text-gray">ลงทะเบียนด้วย</div>

        <v-radio-group v-model="isIdCard" row @change="cleanData">
          <v-radio label="เลขบัตรประชาชน" :value="true"></v-radio>
          <v-radio label="เลขพาสปอร์ต" :value="false"></v-radio>
        </v-radio-group>
        <ValidationProvider
          v-if="isIdCard"
          rules="required|max13"
          name="เลขบัตรประชาชน"
          v-slot="{ errors }"
        >
          <v-text-field-simplemask
            class="mt-0"
            key="`card-1`"
            v-model="input.idcard"
            label="เลขบัตรประชาชน"
            :properties="{
              type: 'tel',
              prefix: '',
              suffix: '',
              dense: true,
              readonly: false,
              disabled: false,
              outlined: true,
              clearable: false,
              placeholder: '',
              error: errors && errors.length ? true : false,
              errorMessages: errors
            }"
            :options="{
              type: 'tel',
              inputMask: '#-####-#####-##-#',
              outputMask: '#############',
              empty: null,
              applyAfter: false,
              alphanumeric: true,
              lowerCase: false
            }"
            v-bind:focus="focus"
            v-on:focus="focus = false"
          />
        </ValidationProvider>

        <ValidationProvider v-else rules="required|max7" name="เลขพาสปอร์ต" v-slot="{ errors }">
          <v-text-field-simplemask
            class="mt-0"
            key="`pass-2`"
            v-model="input.idcard"
            label="เลขพาสปอร์ต"
            :properties="{
              type: 'text',
              prefix: '',
              suffix: '',
              dense: true,
              readonly: false,
              disabled: false,
              outlined: true,
              clearable: false,
              placeholder: '',
              error: errors && errors.length ? true : false,
              errorMessages: errors
            }"
            :options="{
              type: 'text',
              inputMask: '#########',
              outputMask: '#########',
              empty: null,
              applyAfter: false,
              alphanumeric: true,
              lowerCase: false
            }"
            v-bind:focus="focus"
            v-on:focus="focus = false"
          />
        </ValidationProvider>
        <!-- <div
        v-if="submited && isIdCard && input.idcard.length !== 13"
        class="fs-13"
        style="color: red; margin-top: -25px"
      >
        กรอกเลขบัตรประชาชนไม่ครบถ้วน
      </div>
      <div
        v-if="submited && !isIdCard && input.idcard.length < 7"
        class="fs-13"
        style="color: red; margin-top: -25px"
      >
        กรอกเลขพาสปอร์ตไม่ครบถ้วน
      </div> -->
        <div class="text-gray">กรุณาระบุวันเดือนปีเกิด</div>
        <!-- <DatepickerCustomDialog class="w-100 mt-2" v-model="input.date" style="display: inline-block" @input="onchangeDate($event)">
        <template v-slot="{ computedDate }">
          <input class="form-control" name="birth_date" data-vv-as="Birth Date" :value="computedDate" readonly placeholder="วัน/เดือน/ปีค.ศ." style="display: inline-block;background-color:#fff" type="text" />
        </template>
      </DatepickerCustomDialog> -->
        <v-layout row wrap class="mt-5">
          <v-flex xs3>
            <ValidationProvider rules="required|dRules" name="วันที่" v-slot="{ errors }">
              <v-text-field
                dense
                type="text"
                pattern="\d*"
                v-model="inputDate.day"
                autocomplete="off"
                label="วัน"
                min="1"
                max="31"
                maxLength="2"
                outlined
                v-mask="'##'"
                :error="errors && errors.length ? true : false"
                :errorMessages="errors"
              ></v-text-field>
            </ValidationProvider>
          </v-flex>
          <v-flex xs5 class="pl-0">
            <ValidationProvider rules="required|mRules" name="เดือน" v-slot="{ errors }">
              <v-text-field
                dense
                type="text"
                pattern="\d*"
                v-model="inputDate.month"
                autocomplete="off"
                label="เดือน เช่น 08"
                min="1"
                max="12"
                maxLength="2"
                outlined
                v-mask="'##'"
                :error="errors && errors.length ? true : false"
                :errorMessages="errors"
              ></v-text-field>
            </ValidationProvider>
          </v-flex>
          <v-flex xs4 class="pl-0">
            <ValidationProvider rules="required|yRules" name="ปี" v-slot="{ errors }">
              <v-text-field
                dense
                type="text"
                pattern="\d*"
                v-model="inputDate.year"
                autocomplete="off"
                :label="isIdCard ? 'ปี พ.ศ.' : 'ปี ค.ศ.'"
                max="4"
                maxLength="4"
                outlined
                v-mask="'####'"
                :error="errors && errors.length ? true : false"
                :errorMessages="errors"
              ></v-text-field>
            </ValidationProvider>
          </v-flex>
        </v-layout>
        <div v-if="submited && !input.date" class="fs-13 mt-5" style="color: red">
          วันเดือนปีเกิดรูปแบบไม่ถูกต้อง
        </div>
        <div v-if="submited && !input.date" class="fs-13" style="color: red">
          **ตัวอย่าง 01 06 2564
        </div>
        <!-- <div class="border-input mt-5 p-2"></div> -->
        <div class="flex-all-center flex-wrap mt-8">
          <v-btn
            :loading="loading"
            @click="nextRegis"
            class="col-8 main-btn"
            style="color: white"
            color="#23409a"
            >ถัดไป</v-btn
          >
          <v-btn @click="$emit('back')" class="col-8 main-btn mt-3" color="#f5f5f5">ย้อนกลับ</v-btn>
        </div>
        <div class="fs-12 mt-2" style="color: red" v-if="count > 4">
          ไม่สามารถลงทะเบียนได้เนื่องจากกรอก เลขบัตรปชช. ผิดเกิน 5 ครั้ง
        </div>
      </div>
    </ValidationObserver>

    <dialog-duplicate-account
      :show="showDialogDuplicateAccount"
      @onClose="handleCancelDuplicateAccount"
      :hasRegisteredAccount="hasRegisteredAccount"
      :hasEtaxBill="hasEtaxBill"
      :lastestLineAccount="lastestLineAccount"
      @onChangeLineAccount="onChangeLineAccount"
    ></dialog-duplicate-account>
  </div>
</template>

<script>
import { TheMask } from 'vue-the-mask'
import DatepickerCustomDialog from '@/components/DatepickerCustomDialog.vue'
import axios from 'axios'
import config from '@/config'
import moment from 'moment'
import api from '@/api'
import otpApi from '@/api/otp'
import DialogDuplicateAccount from '../DialogDuplicateAccount.vue'
import { formatThaiDate } from '@/utils/dateFormat'

import { extend } from 'vee-validate'

extend('max13', {
  message: 'รูปแบบบัตรประชาชนไม่ถูกต้อง',
  validate: value => {
    if (value && value.length == 13) {
      return true
    } else {
      return false
    }
  }
})

extend('max7', {
  message: 'เลขพาสปอร์ตไม่ถูกต้อง',
  validate: value => {
    if (value && value.length > 7) {
      return true
    } else {
      return false
    }
  }
})

extend('dRules', {
  message: 'วันที่ไม่ถูกต้อง',
  validate: value => {
    if (!!value && value < 32 && value > 0) {
      return true
    } else {
      return false
    }
  }
})

extend('mRules', {
  message: 'เดือนไม่ถูกต้อง',
  validate: value => {
    if (!!value && value < 13 && value > 0) {
      return true
    } else {
      return false
    }
  }
})

extend('yRules', {
  message: 'ปีไม่ถูกต้อง',
  validate: value => {
    if (!value || value < 1000) {
      return false
    } else {
      return true
    }
  }
})

export default {
  components: { TheMask, DatepickerCustomDialog, DialogDuplicateAccount },
  data() {
    return {
      isIdCard: true,
      submited: false,
      inputDate: {
        day: null,
        month: null,
        year: null
      },
      focus: false,
      loading: true,
      checkbox: false,
      input: {
        idcard: '',
        date: null
      },
      count: 0,
      loading: false,
      showDialogDuplicateAccount: false,
      hasRegisteredAccount: false,
      hasEtaxBill: false,
      lastestLineAccount: ''
    }
  },
  watch: {
    inputDate: {
      immediate: true,
      deep: true,
      handler(inputDate) {
        if (
          inputDate.day > 0 &&
          inputDate.day < 32 &&
          inputDate.month > 0 &&
          inputDate.month < 13 &&
          inputDate.year &&
          inputDate.year.length >= 4
        ) {
          let d = inputDate.day ? parseInt(inputDate.day) : 0
          let m = inputDate.month ? parseInt(inputDate.month) : 0
          let y = inputDate.year ? parseInt(inputDate.year) : 0
          let updateYear = 0
          if (this.isIdCard) {
            updateYear = 543
          }
          if (d && m && y) {
            this.input.date = moment(
              new Date(
                parseInt(inputDate.year) - updateYear,
                parseInt(inputDate.month) - 1,
                inputDate.day
              )
            ).format('YYYY-MM-DD')
          } else {
            this.input.date = null
          }
        } else {
          this.input.date = null
        }
      }
    }
  },
  mounted() {
    this.count = this.$store.state.regiscount
    // let date_split = this.$store.state.regiscountTime ? this.$store.state.regiscountTime.split(' ') : moment().format('')
    // let dateNow = new Date()
    // dateNow = moment(dateNow).format('DD MM YYYY HH mm')
    // dateNow = dateNow.split(' ')
    // if (
    //   dateNow[0] > date_split[0] ||
    //   dateNow[1] > date_split[1] ||
    //   dateNow[2] > date_split[2] ||
    //   dateNow[3] > date_split[3]
    // ) {
    //   this.$store.dispatch('conutRegis', 0)
    // }
    this.$store.dispatch('conutRegis', 0)
  },
  methods: {
    onChangeLineAccount() {
      this.showDialogDuplicateAccount = false
      this.$emit('next')
    },
    handleCancelDuplicateAccount() {
      this.showDialogDuplicateAccount = false
      if (this.$liff && this.$liff.isInClient()) {
        this.$liff.closeWindow()
      } else {
        this.$store.dispatch('messengerClose')
      }
    },
    cleanData(val) {
      this.input.idcard = ''
      if (this.inputDate.year && this.inputDate.year > 543) {
        if (val) {
          try {
            this.inputDate.year = this.inputDate.year
              ? Number(this.inputDate.year) + 543 + ''
              : this.inputDate.year
          } catch (error) {
            //
          }
        } else {
          try {
            this.inputDate.year = this.inputDate.year
              ? Number(this.inputDate.year) - 543 + ''
              : this.inputDate.year
          } catch (error) {
            //
          }
        }
      }
    },
    async nextRegis() {
      this.submited = true
      let IsValid = await this.$refs.observer.validate()

      if (!IsValid || !this.input.date) {
        return
      }
      let body = {
        user_id: this.$store.state.userid,
        id_card: this.input.idcard,
        birth_day: formatThaiDate(this.input.date),
        page_id: config.pageid
      }

      this.loading = true

      try {
        let res = await otpApi.getSmsNo({ body })

        this.handleSetRegisterData(res.data.data)
        let tempInput = {
          ...this.input,
          phoneno: null,
          phoneNumbers: res.data.data.phoneNumbers,
          status: res.data.data.status,
          etaxebill: res.data.data.etaxebill_ncap,
          NmEtaxebill: res.data.data.etaxebill_nmny
        }
        this.$store.state.regisData = tempInput
        if (this.hasRegisteredAccount) {
          this.showDialogDuplicateAccount = true
        } else {
          this.$emit('next')
        }
      } catch (error) {
        this.$swal.fire({
          type: 'error',
          text: 'ไม่มีข้อมูลในระบบ'
        })
        this.count++
        this.$store.dispatch('conutRegis', this.count)
      } finally {
        this.loading = false
      }
    },
    handleSetRegisterData(data) {
      this.hasRegisteredAccount = data.status && data.status == 'dup' ? true : false
      this.hasEtaxBill = data.etaxebill_ncap && data.etaxebill_ncap == 'regis' ? true : false
      this.hasNmEtaxBill = data.etaxebill_nmny && data.etaxebill_nmny == 'regis' ? true : false
      this.$store.state.hasRegisteredAccount = this.hasRegisteredAccount
      this.lastestLineAccount =
        data.selectUser && data.selectUser.first_name ? data.selectUser.first_name : ''
      this.$store.state.hasEtaxBill = this.hasEtaxBill
      this.$store.state.hasNmEtaxBill = this.hasNmEtaxBill
    },
    onchangeDate(date) {
      this.$set(this.input, 'date', date)
    }
  },
  computed: {
    query() {
      return this.$store.state.query
    },
    view() {
      return this.$store.state.query.view
    }
  }
}
</script>

<style>
.v-text-field__slot > label {
  background-color: white;
  top: 14px !important;
}
.v-text-field--outlined.v-input--dense .v-label--active {
  transform: translateY(-24px) scale(0.75) !important;
}
.form-control {
  border-color: #888 !important;
}
.v-text-field > .v-input__control > .v-input__slot {
  transition: background 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
</style>
